@if (isVisible()) {
<div class="change-log-backdrop" (click)="close()"></div>
<div class="change-log-dialog">
  <div class="change-log-header">
    <h3>Change Log: {{ entityName }}</h3>
    <button class="close-button" (click)="close()" aria-label="Close">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <div class="change-log-content">
    @if (isLoading()) {
    <div class="loading-container">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
      <p>Loading change log...</p>
    </div>
    } @else {
      @if (shouldShowFilterToggle()) {
      <div class="change-log-filters">
        <button
          class="change-log-filter-button"
          [class.active]="activeFilter() === 'status'"
          (click)="setFilter('status')"
        >
          Status History
        </button>
        <button
          class="change-log-filter-button"
          [class.active]="activeFilter() === 'all'"
          (click)="setFilter('all')"
        >
          All Changes
        </button>
      </div>
      }

      @if (displayedLogs.length === 0) {
      <div class="empty-container">
        <i class="pi pi-info-circle" style="font-size: 2rem; color: #719eb6"></i>
        <p>{{ getEmptyMessage() }}</p>
      </div>
      } @else {
      <div class="change-log-list">
        @for (entry of displayedLogs; track entry.log.ID) {
        <div class="change-log-entry">
          <div class="change-log-entry-header">
            <div class="change-log-entry-meta">
              <span class="change-log-date">{{
                entry.log.Date | date : "MM/dd/yyyy hh:mm a"
              }}</span>
              <span class="change-log-user">{{ getUserName(entry.log) }}</span>
            </div>
            <span
              class="change-log-action"
              [style.background-color]="
                getActionColor(entry.parsedData?.Action || 'Unknown')
              "
            >
              <i
                [class]="getActionIcon(entry.parsedData?.Action || 'Unknown')"
                style="margin-right: 0.25rem"
              ></i>
              {{ entry.parsedData?.Action || "Unknown" }}
            </span>
          </div>

          @if (getStatusSummary(entry.parsedData)) {
          <div class="change-log-status-summary">
            {{ getStatusSummary(entry.parsedData) }}
          </div>
          }

          @if (entry.parsedData) {
          <div class="change-log-details">
            @for (key of getChangeKeys(entry.parsedData); track key) {
            @if (key !== 'Action') {
            <div class="change-log-field">
              <span class="field-name">{{ formatPropertyName(key) }}:</span>
              <span
                class="field-value"
                [innerHTML]="formatFieldValue(key, entry.parsedData[key])"
              ></span>
            </div>
            } }
          </div>
          }
        </div>
        }
      </div>
      }
    }
  </div>
</div>
}
